'use client';

import { c as _c } from "react/compiler-runtime";
type LoadingTabSkeletonProps = {
  label: string;
};
export const LoadingTabSkeleton = t0 => {
  const $ = _c(2);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <div className="flex min-w-20 items-center justify-between"><span>{label}</span></div>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};